import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";

/** Props Interface */
interface AssignmentReferenceBookingAnswerActionsProps {
	isEditing: boolean;
	onAccept: () => void;
	onReject: () => void;
	onEdit: () => void;
	onCancel: () => void;
	onConfirm: () => void;
}

/**
 * The host's three answers to a booking, as the native review offers them; the answer given shows
 * in the slate above, so the buttons stay alike and only their icons carry colour. While a
 * correction is open, the row offers only to drop it or to take it.
 */
export function AssignmentReferenceBookingAnswerActions({
	isEditing,
	onAccept,
	onReject,
	onEdit,
	onCancel,
	onConfirm,
}: AssignmentReferenceBookingAnswerActionsProps) {
	/** Context */
	const { t } = useTranslation();

	/** Guard */
	if (isEditing) {
		return (
			<div className="justify-end h-stack">
				<Button
					size="xs"
					variant="white"
					onClick={onCancel}
				>
					{t("general.cancel")}
				</Button>
				<Button
					size="xs"
					variant="white"
					icon={
						<Icon
							name="Check"
							className="text-emerald-500"
						/>
					}
					onClick={onConfirm}
				>
					{t("general.confirm")}
				</Button>
			</div>
		);
	}

	/** Render */
	return (
		<div className="gap-2 grid grid-cols-3">
			<Button
				size="xs"
				variant="white"
				icon={
					<Icon
						name="X"
						className="text-red-500"
					/>
				}
				onClick={onReject}
			>
				{t("partners.reject_booking")}
			</Button>
			<Button
				size="xs"
				variant="white"
				icon={
					<Icon
						name="Check"
						className="text-emerald-500"
					/>
				}
				onClick={onAccept}
			>
				{t("partners.accept_booking")}
			</Button>
			<Button
				size="xs"
				variant="white"
				icon={
					<Icon
						name="Pencil"
						className="text-amber-500"
					/>
				}
				onClick={onEdit}
			>
				{t("general.edit")}
			</Button>
		</div>
	);
}
